import React from 'react';

import HeaderWrapper from 'components/DetailsComponents/HeaderWrapper';
import BackButton from 'components/BackButton/BackButton';

import { useParams } from 'react-router-dom';
import { useMobileViewport } from 'hooks/useMobileViewport';

export const Header = ({ onCancel }) => {
  const { id } = useParams();
  const isMobile = useMobileViewport();

  return (
    <HeaderWrapper title={`${id ? 'Edit' : 'Create'} request`}>
      {isMobile && <BackButton onCancel={onCancel} />}
    </HeaderWrapper>
  );
};
